const getClosestElement = (draggableElements, y) => {
  const closeNode = draggableElements.reduce(
    (closest, child) => {
      const box = child.getBoundingClientRect();
      const offset = y - box.top - box.height / 2;
      if (offset < 0 && offset > closest.offset) {
        return { offset, element: child };
      }
      return closest;
    },
    { offset: Number.NEGATIVE_INFINITY },
  );

  return closeNode?.element;
};

/**
 * Get the element before which dragging element needs to be inserted
 */
export default (droppable, y, className) => {
  const query = `.${className}`;
  const draggableElements = [...droppable.querySelectorAll(query)];

  const closestEl = getClosestElement(draggableElements, y);
  return closestEl;
};
